import { Separator } from '@radix-ui/themes';
import { Header } from './header';

type LayoutProps = {
  leftSidebar1?: React.ReactNode;
  leftSidebar2?: React.ReactNode;
  children?: React.ReactNode;
};

export function Layout({ leftSidebar1, leftSidebar2, children }: LayoutProps) {
  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <Header />
      <div className="flex flex-grow">
        <aside className="flex shadow-lg border-r border-gray-200">
          <div className="flex-none w-[332px] h-full z-20">{leftSidebar1}</div>
          <Separator
            size="4"
            orientation="vertical"
            className="border-gray-200"
          />
          <div className="flex-none w-[320px] h-full">{leftSidebar2}</div>
        </aside>
        <div className="basis-[100%] flex-grow-1 h-full">{children}</div>
      </div>
    </div>
  );
}
